import { KPI_TONE_DOT_CLASS, type KpiTone } from "./kpiTypes";

/**
 * 8px solid dot used by Phase 4 header micro-indicator. Built in Phase 1 so
 * Phase 4 is plumbing-only; the icon is purely decorative — pair with an
 * adjacent text label or visually-hidden span when used as the only signal.
 */
export function StatusDot(props: { tone: KpiTone; ariaLabel?: string }) {
  const cls = KPI_TONE_DOT_CLASS[props.tone];
  return (
    <span
      className={["inline-block h-2 w-2 rounded-full", cls].join(" ")}
      aria-hidden={!props.ariaLabel}
      aria-label={props.ariaLabel}
      role={props.ariaLabel ? "status" : undefined}
    />
  );
}
